module.exports = __webpack_public_path__ + "static/img/nav-country-bg.823ef21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/nav-country-bg.png
// module id = VH3U
// module chunks = 4